export interface WorldState {
  binstViewReady: boolean;
  threeRendererReady: boolean;
  pixiRendererReady: boolean;
  surfacesReady: boolean;
  surfaceDebug: boolean;
  debuggers: {};
  tickCount: number;
}

export const initialState: WorldState = {
  binstViewReady: false,
  threeRendererReady: false,
  pixiRendererReady: false,
  surfacesReady: false,
  surfaceDebug: false,
  debuggers: {},
  tickCount: 0,
};
